import React from 'react';
import cn from 'classnames';
import { CheckmarkerIcon, CheckboxOutlinedIcon, ReturnIcon, WarningIcon, TimeIcon, ParcelIcon, CashOnDelivery, } from "../Icon";
import BodyText from "../Typography/texts/BodyText";
import MetaText from "../Typography/texts/MetaText";
import styles from './StatusText.module.scss';
const TYPE_MAP = {
    paid: {
        color: styles.paid,
        icon: CheckmarkerIcon,
    },
    unpaid: {
        color: styles.unpaid,
        icon: TimeIcon,
    },
    overdue: {
        color: styles.overdue,
        icon: WarningIcon,
    },
    returned: {
        color: styles.returned,
        icon: ReturnIcon,
    },
    activated: {
        color: styles.activated,
        icon: CheckmarkerIcon,
    },
    parcel: {
        color: styles.parcel,
        icon: ParcelIcon,
    },
    cash: {
        color: styles.cash,
        icon: CashOnDelivery,
    },
    check: {
        color: styles.check,
        icon: CheckboxOutlinedIcon,
    },
};
export const getTypes = Object.keys(TYPE_MAP);
const StatusText = ({ className, type, icon, children }) => {
    var _a;
    const IconComp = icon && type && TYPE_MAP[type].icon;
    const typeColor = type && ((_a = TYPE_MAP[type]) === null || _a === void 0 ? void 0 : _a.color);
    if (!children)
        return null;
    return (React.createElement(BodyText, { className: cn(styles.container, className) },
        IconComp && React.createElement(IconComp, { size: "small", className: cn(styles.icon, typeColor) }),
        React.createElement(MetaText, { className: cn(styles.text, typeColor) }, children)));
};
export default StatusText;
//# sourceMappingURL=StatusText.js.map